import Cookies from "js-cookie";

/**
 * CookieからCSRFトークンを取り出す。
 * 画面表示時に1度だけ取得作業を行い、以降値は更新されない。
 *
 * @returns トークン
 */
export const getCsrfToken = (() => {
    const token = Cookies.get("csrftoken");

    if (!token) {
        console.error("CSRF token not found in cookies. API requests may fail.");
    }

    return () => token ?? "";
})();
